import React, { Component } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";

import styles from "./AuthDrawer.css";

class RegisterThree extends Component {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSkip = this.handleSkip.bind(this);

    this.state = {
      industry: "",
      industries: authDrawerConstants.INDUSTRIES,
      job_title: "",
    };
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    this.props.authDrawerActions
      .setOptionalInfo({
        industry: this.state.industry,
        job_title: this.state.job_title,
      })
      .then(() => {
        this.props.authDrawerActions
          .registerEmail(this.props.authDrawer.userData)
          .then(() => {
            this.props.authDrawerActions.toggleAuthDrawer(false);
          });
      });
  }

  handleSkip() {
    return this.props.authDrawerActions
      .registerEmail(this.props.authDrawer.userData)
      .then(() => {
        this.props.authDrawerActions.toggleAuthDrawer(false);
      });
  }

  render() {
    return (
      <div className={styles.container}>
        <h3>Thanks for signing up!</h3>

        <div className={styles.marginTop20}>
          In order to help us deliver news that will be most relevant to you,
          please tell us a little about yourself.
        </div>

        <form onSubmit={this.handleSubmit}>
          <div className={styles.marginTop40}>
            <select onChange={this.handleChange} name="industry">
              <option>What industry do you work in?</option>

              {this.state.industries.map((industry, index) => {
                return (
                  <option key={index} value={industry}>
                    {industry}
                  </option>
                );
              })}
            </select>
          </div>

          <div className={styles.marginTop20}>
            <input
              onChange={this.handleChange}
              name="job_title"
              type="text"
              placeholder="In what role?"
            />
          </div>

          <div className={styles.nextButton}>
            <button
              type="submit"
              className={classNames(
                styles.blueButton1,
                styles.block,
                styles.centered
              )}
            >
              Finish
            </button>
          </div>
        </form>

        <div className={classNames(styles.marginTop20, styles.textCenter)}>
          <button
            onClick={this.handleSkip}
            className={classNames(
              styles.blackLink,
              styles.bold,
              styles.skipButton
            )}
          >
            Skip for now
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterThree);
